import Chart from "react-google-charts";
import { Card, CardBody, Col } from "reactstrap";
import { GoogleChartProps } from "../../../../types/General";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";

const CommonChart: React.FC<GoogleChartProps> = ({ title, bodyClass, colClass, data, divClass }) => {
  return (
    <Col sm="12" className={colClass ?? "col-xl-6 box-col-6"}>
      <Card className="overflow-hidden">
        <CommonCardHeader title={title} />
        <CardBody className={`chart-block ${bodyClass ?? ""}`}>
          <div className={divClass} id="column-chart1">
            <Chart
              width={data.width}
              height={data.height}
              chartType={data.chartType}
              loader={<div>{'Loading Chart'}</div>}
              data={data.data}
              options={data.options}
            />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CommonChart;